import React from 'react';
import {
 SideNavigation,
 Flash
} from 'AWS-UI-Components-React';
import MidwayIdentityJavaScriptClient from 'midway-identity-java-script-client';

export const Header = ({title, counter}) => {

  return <div className='awsui-util-action-stripe'>
    <div className='awsui-util-action-stripe-title'>
      <h2>{title}&nbsp;
        {counter ? <span className='custom-action-stripe-counter'>{counter}</span> : ''}
      </h2>
    </div>
    <div className='awsui-util-action-stripe-group'>
    </div>
  </div>
};

export const FlashMessage = () => (
  <Flash
    type='success'
    content='Resource created successfully'
    dismissible={true}
  ></Flash>
);

export const config = {
    "apiEndpoint": "api.alpha.compromise-detection.fraud.aws.a2z.com",
    "cognitoPoolId": "us-west-2:08c9c304-50e8-4a4c-99e5-b87f2ec3a30a", 
    "region": "us-west-2"
}

export class JSClient {

    constructor(props){
        this.props = props || {};
        this.clientLoaded = this.clientLoaded.bind(this);
        this.getIdentity = this.getIdentity.bind(this);
        this.getEventsDetail = this.getEventsDetail.bind(this);
        this.getSummary = this.getSummary.bind(this);
        this.makeClient = this.makeClient.bind(this);
        this.makeClient(config)
        console.log(`Attempting to instantiate MidwayClient`);
   }

   makeClient(settings){
        let endpoint = settings['apiEndpoint'];
        if (!endpoint.startsWith("http")){
            endpoint = `https://${endpoint}`;
        }
        const client = new MidwayIdentityJavaScriptClient({
            httpEndpoint: endpoint,
            cognitoIdentityPoolId: settings['cognitoPoolId'],
            region: settings['region']
        });
        console.log("Client built from discovered settings.");
        this.clientLoaded(client);
    }
 
   onErr(err) {
    console.trace()
     console.log(`Midway client threw error ${err}`);
   }

    clientLoaded(client){
        this.client = client;
        if (this.props.hasOwnProperty("onReady")){
            this.props.onReady();
        }
    }

    getEventsDetail(accountId, startTime, endTime, limit, page, category, order, filtersPath, callback, errorCallback) {
      const reqStartTime = `${startTime ? '&startTime=' + startTime  : ''}`;
      const reqEndTime = `${endTime ? '&endTime=' + endTime : ''}`;
      const reqLimit = `${limit ? '&limit=' + limit : ''}`;
      const reqPage = `${page ? '&page=' + page : ''}`;
      const reqCategory = `${category ? '&category=' + category : ''}`;
      const reqOrder = `${order ? '&order=' + order : ''}`;
      const resourcePath = `/record/{accountId}/detail?accountId=${accountId}${reqStartTime}${reqEndTime}${reqLimit}${reqPage}${reqCategory}${reqOrder}${filtersPath}`;
      this.client.get(resourcePath).then( function(response){
            callback(response.data);
        }).catch(function (error) {
          console.log(error);
          if (errorCallback) {
            errorCallback(error);
          }
        });
    }

    getSummary(accountId, startTime, endTime, filtersPath, callback, errorCallback) {
      const required = `/record/{accountId}/summaries?accountId=${accountId}`;
      const reqStartTime = `${startTime ? '&startTime=' + startTime : ''}`;
      const reqEndTime = `${endTime ? '&endTime=' + endTime : ''}`;
      const finalPath = required + reqStartTime + reqEndTime + filtersPath;
      this.client.get(finalPath).then( function(response){
            callback(response.data);
        }).catch(function (error) {
          console.log(error);
          if (errorCallback) {
            errorCallback(error);
          }
        });
    }

    getIdentity(callback, errorCallback){
        this.client.get(`identity`)
        .then( function(response){
            callback(response.data);
        }).catch(function (error) {
          console.log(error);
          if (errorCallback) {
            errorCallback(error);
          }
        });
    }

    
    
};


export class Navigation extends React.Component {
  onFollowHandler(ev) {
    // keep the locked href for our demo pages
    ev.preventDefault();
  }

  render() {
    return (
      <SideNavigation
        //items={items}
        //header={header}
        //activeHref={this.props.activeHref}
        //onFollow={this.onFollowHandler.bind(this)}
      />
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/common.jsx